module.exports = __webpack_public_path__ + "static/img/honorPadPlay.a8eec247.png";